import { Breadcrumbs } from "@mui/material";
import Container from "components/container";
import FileViewButton from "components/file-view-button";
import Layout from "components/layout";
import { RichTextContainer } from "components/rich-text-container";
import SafeHtml from "components/safe-html";
import { ROUTES } from "constants/routes";
import { useGetInformationalContentArticle } from "hooks/api/use-get-informational-content-article";
import { useDictionary } from "hooks/use-dictionary";
import useFormattedDate from "hooks/use-formatted-date";
import { useRequiredParams } from "hooks/use-required-params";
import { Link, generatePath } from "react-router-dom";
import SectionTitle from "../home/components/section-title";

export const InformationalContentArticlePage = () => {
  const { informationalContentArticleId } = useRequiredParams<{ informationalContentArticleId: string }>();
  const { data: article, isLoading, isError } = useGetInformationalContentArticle(+informationalContentArticleId);
  const formattedDate = useFormattedDate(article?.publishAt);
  const dict = useDictionary();

  if (isLoading || isError || !article || !article.section) {
    return null;
  }

  const attachmentFiles = article.files?.filter((file) => !file.url || !article.content.includes(file.url));

  return (
    <Layout>
      <div className="space-y-8 py-12">
        <Container className="bg-theme-background" childClassName="space-y-4">
          <Breadcrumbs>
            <Link to={ROUTES.home}>{dict.common.breadcrumbsRoot}</Link>
            <Link to={generatePath(ROUTES.informationalContent.sectionList, { section: article.section })}>
              {dict.informationalContent.sections[article.section]}
            </Link>
            <div>{article.title}</div>
          </Breadcrumbs>
          <RichTextContainer>
            <div className="space-y-5">
              <SectionTitle>{article.title}</SectionTitle>
              <div className="bg-white border rounded p-5 space-y-5">
                <div className="bg-theme-border leading-6 rounded-full px-3 text-xs w-fit">{formattedDate}</div>
                <div className="space-y-2">
                  <div className="font-bold mb-2">{dict.news.content}</div>
                  <SafeHtml html={article.content} />
                </div>
                {attachmentFiles && attachmentFiles.length > 0 && (
                  <div className="space-y-2">
                    <div className="font-bold mb-2">{dict.news.documents}</div>
                    <div className="space-y-3">
                      {attachmentFiles.map((file) => (
                        <FileViewButton file={file} key={file.fileName} />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </RichTextContainer>
        </Container>
      </div>
    </Layout>
  );
};
